import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "invisible.icon",
  "use": "invisible.icon-usage",
  "viewBox": "-9317.701 -4687.062 31.392 27.123",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-9317.701 -4687.062 31.392 27.123\" id=\"invisible.icon\"><path d=\"M16.7,8.71a7.14,7.14,0,0,1,7.138,7.138,6.928,6.928,0,0,1-.514,2.612l4.168,4.168a16.869,16.869,0,0,0,4.9-6.781,16.883,16.883,0,0,0-15.7-10.706,16.624,16.624,0,0,0-5.682,1L14.09,9.224A6.928,6.928,0,0,1,16.7,8.71ZM2.428,4.813,5.682,8.068l.657.657A16.851,16.851,0,0,0,1,15.848a16.876,16.876,0,0,0,21.955,9.507l.6.6,4.183,4.168,1.813-1.813L4.24,3Zm7.894,7.894,2.213,2.213a4.027,4.027,0,0,0-.114.928A4.277,4.277,0,0,0,16.7,20.13a4.027,4.027,0,0,0,.928-.114l2.213,2.213a7.091,7.091,0,0,1-9.522-9.522Zm6.153-1.113,4.5,4.5L21,15.862a4.277,4.277,0,0,0-4.283-4.283Z\" transform=\"translate(-9318.701 -4690.062)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/invisible.icon.svg
// module id = Ckzy
// module chunks = 13